export enum DocumentGroups {
	CAD = 'CAD',
	CAD_TEMP_IMPORTS = 'CAD_TEMP_IMPORTS',
	CAD_MASS_ADJUSTMENT_REQUEST = 'CAD_MASS_ADJUSTMENT_REQUEST',
	Rulings = 'RULINGS',
	Appeal = 'APPEAL',
	CustomsBroker = 'CUSTOMS_BROKER',
	DutyFreeShop = 'DUTY_FREE_SHOP',
	SufferanceWarehouse = 'WAREHOUSE_SUFFERANCE',
	CustomsBondedWarehouse = 'WAREHOUSE_BONDED',
	Edi = 'EDI',
	Exporter = 'EXPORTER',
	Importer = 'IMPORTER',
	Carrier = 'CARRIER',
	ThirdParty = 'THIRD_PARTY',
	ImporterEdi = 'IMPORTER_EDI',
	ImporterNonResident = 'IMPORTER_NON_RESIDENT',
	ImporterRpp = 'IMPORTER_RPP',
	ImporterDuties = 'IMPORTER_DUTIES',
	ImporterCanadianGoodsAbroad = 'IMPORTER_GOODS',
	ImporterContainerBank = 'IMPORTER_CONTAINER',
	CarrierSummary = 'CARRIER_SUMMARY',
	ImporterCoastingTradeLicence = 'IMPORTER_COASTING',
	ImporterDutiesRemission = 'IMPORTER_DUTIES_REMISSION',
	ImporterDutiesRemission120 = 'IMPORTER_DUTIES_REMISSION_120',
	ImporterTrustedTrader = 'IMPORTER_TRUSTED_TRADER',
	ExporterEdi = 'EXPORTER_EDI',
	CustomsBrokerEdi = 'CUSTOMS_BROKER_EDI',
	WarehouseSufferanceEdi = 'WAREHOUSE_SUFFERANCE_EDI',
	WarehouseBondedEdi = 'WAREHOUSE_BONDED_EDI',
	CarrierEdi = 'CARRIER_EDI',
	CarrierBonded = 'CARRIER_BONDED',
	CarrierCsa = 'CARRIER_CSA',
	CAD_DDB = 'CAD_DDB',
	SOA = 'SOA',
	CAD_MASTER_PROVISIONAL = 'CAD_MASTER_PROVISIONAL',
	PROGRAM_COMPLIANCE = 'PROGRAM_COMPLIANCE',
	TRADE_COMPLIANCE = 'TRADE_COMPLIANCE',
	SIMA_COMPLIANCE = 'SIMA_COMPLIANCE',
	CAD_CSA_DRAWBACK = 'CAD_CSA_DRAWBACK',
	CLAIMS = 'CLAIMS',
	PENALTY_ASSESSMENT = 'PENALTY_ASSESSMENT',
	CORRECTION = 'CORRECTION',
	PROGRAM_COMPLIANCE_RPP = 'PROGRAM_COMPLIANCE_RPP',
	ENFORCEMENT_ACTION = 'ENFORCEMENT_ACTION',
	CAD_REPORTS = 'CAD_REPORTS',
	SIMA_APPEAL = 'SIMA_APPEAL',
	TRUSTED_TRADER_APPEAL = 'TRUSTED_TRADER_APPEAL',
	SDA = 'CAD_CSA_DRAWBACK',
  CAD_Async = 'CAD_ASYNC',
  CAD_TEMP_IMPORTS_Async = 'CAD_TEMP_IMPORTS_ASYNC',
  CAD_DDB_Async = 'CAD_DDB_ASYNC',
}
